<template>
    <div>
        <b-container fluid class="mt--7 pb-4">
            <b-row>
                <b-col cols="12" class="order-xl-1">
                    <b-card title="Company Settings" shadow type="secondary">
                        <b-card-body>
                            <b-form @submit.prevent>
                                <h6 class="heading-small text-muted mb-4">
                                    Business Information
                                </h6>
                                <div class="pl-lg-4">
                                    <b-row>
                                        <b-col cols="6">
                                            Name
                                            <b-input-group class="mb-3">
                                                <b-input-group-prepend>
                                                    <b-input-group-text>
                                                        <b-icon
                                                            icon="file-person-fill"
                                                        ></b-icon>
                                                    </b-input-group-text>
                                                </b-input-group-prepend>

                                                <b-form-input
                                                    placeholder="Name"
                                                    v-model="model.name"
                                                    type="text"
                                                ></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="6">
                                            Telephone
                                            <b-form>
                                                <b-input-group class="mb-3">
                                                    <b-input-group-prepend>
                                                        <b-input-group-text>
                                                            <b-icon
                                                                icon="telephone-fill"
                                                            ></b-icon>
                                                        </b-input-group-text>
                                                    </b-input-group-prepend>

                                                    <b-form-input
                                                        placeholder="+(876)111-1111"
                                                        v-model="model.phone"
                                                        type="text"
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <div class="row">
                                        <b-col cols="6">
                                            Email
                                            <b-form>
                                                <b-input-group class="mb-3">
                                                    <b-input-group-prepend>
                                                        <b-input-group-text>
                                                            <b-icon
                                                                icon="envelope"
                                                            ></b-icon>
                                                        </b-input-group-text>
                                                    </b-input-group-prepend>

                                                    <b-form-input
                                                        placeholder="Example@oms.com"
                                                        v-model="model.email"
                                                        type="email"
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-form>
                                        </b-col>
                                    </div>
                                </div>
                                <link
                                    rel="stylesheet"
                                    href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"
                                />
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-2">
                                    Business Location
                                </h6>
                                <div class="pl-lg-4">
                                    <b-row>
                                        <b-col>
                                            Address
                                            <b-form>
                                                <b-input-group class="mb-3">
                                                    <b-input-group-prepend>
                                                        <b-input-group-text>
                                                            <b-icon
                                                                icon="journal-medical"
                                                            ></b-icon>
                                                        </b-input-group-text>
                                                    </b-input-group-prepend>

                                                    <b-form-input
                                                        placeholder="Address"
                                                        v-model="model.street"
                                                        type="text"
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-form>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="4">
                                            <b-form-group
                                                id="fieldset-city"
                                                label="City"
                                                label-for="City"
                                            >
                                                <b-form-input
                                                    label="City"
                                                    placeholder="City"
                                                    v-model="model.city"
                                                    trim
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="4">
                                            <b-form-group
                                                id="fieldset-country"
                                                label="Country"
                                                label-for="input-country"
                                            >
                                                <b-form-select
                                                    id="input-country"
                                                    v-model="model.country"
                                                    :options="countries"
                                                ></b-form-select>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="4">
                                            <b-form-group
                                                id="fieldset-city"
                                                label="Postal Code"
                                                label-for="Postal"
                                            >
                                                <b-form-input
                                                    id="Postal"
                                                    placeholder="Postal Code"
                                                    v-model="model.postal"
                                                    trim
                                                ></b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>
                                <hr class="my-4" />
                                <!--Logo and Tagline-->
                                <div class="pl-lg-4">
                                    <b-row>
                                        <b-col>
                                            Business Logo
                                            <b-form>
                                                <b-input-group class="mb-3">
                                                    <b-input-group-prepend>
                                                        <b-input-group-text>
                                                            <b-icon
                                                                icon="image"
                                                            ></b-icon>
                                                        </b-input-group-text>
                                                    </b-input-group-prepend>

                                                    <link-modal
                                                        v-model="model.logo"
                                                    ></link-modal>
                                                </b-input-group>
                                            </b-form>
                                        </b-col>
                                        <div class="w-100"></div>
                                        <b-col>
                                            Business Tagline
                                            <b-form>
                                                <b-input-group class="mb-3">
                                                    <b-input-group-prepend>
                                                        <b-input-group-text>
                                                            <b-icon
                                                                icon="chat-square-text"
                                                            ></b-icon>
                                                        </b-input-group-text>
                                                    </b-input-group-prepend>

                                                    <b-form-input
                                                        placeholder="Tagline"
                                                        v-model="model.tagline"
                                                        type="text"
                                                    ></b-form-input>
                                                </b-input-group>
                                            </b-form>
                                        </b-col>
                                        <div class="w-100"></div>
                                    </b-row>
                                </div>
                                <hr class="my-4" />

                                <div class="pl-lg-4">
                                    <b-row>
                                        <div class="col-md-12 text-right">
                                            <b-button
                                                v-if="hasPermissionUpdate"
                                                variant="primary"
                                                @click="updateCompany()"
                                                :disabled="submitting"
                                                >{{
                                                    submitting
                                                        ? 'Saving Changes...'
                                                        : 'Save Changes'
                                                }}</b-button
                                            >
                                        </div>
                                    </b-row>
                                </div>
                            </b-form>
                        </b-card-body>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import CountryList from '@/assets/CountryList.json'
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'

import LinkModal from '@/components/LinkModal'

export default {
    name: 'companySettings',
    mixins: [permissionsMixins, popupMixins],
    components: { LinkModal },
    data() {
        return {
            componentName:'Company Setting',
            model: {
                name: 'My Company',
                email: '',
                phone: '',
                street: '',
                city: 'Kingston',
                country: 'Jamaica',
                postal: '',
                logo: '',
                tagline: '',
            },
            submitting: false,
        }
    },
    computed: {
        countries() {
            return CountryList.map(x => ({
                value: x.name,
                text: x.name,
            }))
        },
        settings() {
            const data = this.$store.state.company.settings
            console.log('computed data', data)
            return data
        },
    },
    watch: {
        settings: {
            handler: function (val) {
                this.model = val
            },
            deep: true,
        },
    },
    mounted() {
        this.$store.dispatch('company/fetch')
    },
    methods: {
        async updateCompany() {
            this.submitting = true
            try {
                this.$store.dispatch('company/update', this.model)

                this.genericToast(this.componentName, 'Updated','success',`${this.componentName} succesfully updated`)

                //this.doToast('Success!', 'Company Settings Updated', 'success')
            } catch (err) {
                this.doToast('Failed!', err.message, 'danger')
            } finally {
                this.submitting = false
            }
        },
    },
}
</script>
<style></style>
